import React from 'react';
import { string, object } from 'prop-types';

import Illustration from 'foundations/Illustrations/Illustration';

import styles from './StatisticBlock.css';

const StatisticBlock = ({ label, info, illustration  }) => (
  <div className={styles.statistic}>
    <p className={styles.label}>{label}</p>
    <p className={styles.info}>{info}</p>
    <Illustration customClasses={styles.illustration} {...illustration} />
  </div>
);

StatisticBlock.propTypes = {
  label: string.isRequired,
  info: string.isRequired,
  illustration: object
};

StatisticBlock.displayName = 'StatisticBlock';

export default StatisticBlock;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/AdvantagesBanner/StatisticBlock/StatisticBlock.js